var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavResumenActive = function SvgNavResumenActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nav_resumen_active_svg__Capa_2",
    viewBox: "0 0 32.57 32.52"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav_resumen_active_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.23 12.41H5.17A5.17 5.17 0 0 1 0 7.24V5.18C0 2.32 2.32 0 5.17 0h2.06a5.17 5.17 0 0 1 5.17 5.17v2.06a5.17 5.17 0 0 1-5.17 5.17ZM27.39 12.41h-2.06a5.17 5.17 0 0 1-5.17-5.17V5.18A5.17 5.17 0 0 1 25.33.01h2.06a5.17 5.17 0 0 1 5.17 5.17v2.06a5.17 5.17 0 0 1-5.17 5.17M7.23 32.52H5.17A5.17 5.17 0 0 1 0 27.35v-2.06a5.17 5.17 0 0 1 5.17-5.17h2.06a5.17 5.17 0 0 1 5.17 5.17v2.06a5.17 5.17 0 0 1-5.17 5.17M27.39 32.52h-2.06a5.17 5.17 0 0 1-5.17-5.17v-2.06a5.17 5.17 0 0 1 5.17-5.17h2.06a5.17 5.17 0 0 1 5.17 5.17v2.06a5.17 5.17 0 0 1-5.17 5.17",
    fill: "#500d76"
  }))));
};
export default SvgNavResumenActive;